import React from 'react'
import ReportWrapper from '../ReportWrapper'
import ReportSectionHeading from '../ReportSectionHeading'
import { Stack, Text } from '@mantine/core'
import { useTheme } from '../../../components/ThemeProvider'
import dayjs from 'dayjs'
import TianyanchaRecordCard from '../TianyanchaRecordCard'

interface BidItem {
  publishTime: string
  bidUrl: string
  purchaser: string
  link: string
  bidAmount: string
  title: string
  type: string
  uuid: string
  content: string
  proxy: string
  bidWinner: string
  abs: string
  province: string
  intro: string
  id: string
}

interface Props {
  data: any
  title: string
  sectionIndex?: string
}

const formatAmount = (amount?: string) => {
  if (!amount) return '—'
  const num = Number(amount)
  if (Number.isNaN(num)) return amount
  if (num >= 10000) return `${(num / 10000).toFixed(2)} 万元`
  return `${num.toFixed(2)} 元`
}

const normalizeItems = (items: BidItem[] = []) =>
  items.map((item) => ({
    title: item.title || '—',
    type: item.type || '—',
    purchaser: item.purchaser || '—',
    date: item.publishTime ? dayjs(Number(item.publishTime)).format('YYYY-MM-DD') : '—',
    amount: formatAmount(item.bidAmount),
    province: item.province || '—',
  }))

export default function TianyanchaBids({ data, title, sectionIndex }: Props) {
  let jsonData: any
  try {
    jsonData = JSON.parse(data.tianyancha_bids ?? '{}')
  } catch (error) {
    jsonData = {}
  }

  const bids = normalizeItems(jsonData.items)
  const theme = useTheme()

  return (
    <ReportWrapper>
      <ReportSectionHeading title={title} index={sectionIndex} />
      <div className="mt-2">
        <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
          招投标信息
        </Text>
        <Stack gap="sm" className="mt-3">
          {bids.length === 0 ? (
            <Text c="dimmed" size="sm" ta="center">
              暂无招投标信息
            </Text>
          ) : (
            bids.map((item, index) => (
              <TianyanchaRecordCard
                key={`${item.title}-${index}`}
                number={index + 1}
                recordType="项目"
                fields={[
                  { label: '项目名称', value: item.title, span: 2 },
                  { label: '项目类型', value: item.type },
                  { label: '采购方', value: item.purchaser },
                  { label: '发布日期', value: item.date },
                  { label: '中标金额', value: item.amount },
                  { label: '地区', value: item.province },
                ]}
              />
            ))
          )}
        </Stack>
      </div>
    </ReportWrapper>
  )
}
